import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import toast, { Toaster } from "react-hot-toast";
import "./document.css";
import "./loader.css";

const CourseCompletionCertificate = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  //  Authentication check
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("isLoggedIn");
    if (isAuthenticated !== "true") {
      navigate("/");
    }
  }, [navigate]);

  //  Data fetch using your new API
  useEffect(() => {
    fetch("https://api.sgtu.ac.in/api/sgtuCertificate/category/Course Completion Certificate")
      .then((response) => response.json())
      .then((result) => {
        setTableData(result.data); // sirf data array ko use kiya
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching CGPA certificate data:", error);
        toast.error("Error fetching data");
        setLoading(false);
      });
  }, []);

  const commonCellStyle = {
    fontSize: "12px",
    whiteSpace: "nowrap",
  };

  const columns = [
    { title: "Category", field: "category", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Enrollment", field: "enrollment", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Session", field: "session", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Programme", field: "programme", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Candidate Name", field: "cname", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Father Name", field: "fname", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Mother Name", field: "mname", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Address", field: "address", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "City", field: "city", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Pincode", field: "pincode", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Email", field: "email", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Reason", field: "reason", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    { title: "Fees", field: "fees", headerStyle: commonCellStyle, cellStyle: commonCellStyle },
    {
      title: "Class 10th",
      field: "doc10",
      render: (rowData) => (
        <a href={`https://api.sgtu.ac.in/api/sgtuCertificate/view/${rowData._id}/doc10`} target="_blank" rel="noopener noreferrer">View</a>
      ),
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
    {
      title: "Class 12th",
      field: "doc12",
      render: (rowData) => (
        <a href={`https://api.sgtu.ac.in/api/sgtuCertificate/view/${rowData._id}/doc12`} target="_blank" rel="noopener noreferrer">View</a>
      ),
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
    {
      title: "Graduation",
      field: "grad",
      render: (rowData) => (
        <a href={`https://api.sgtu.ac.in/api/sgtuCertificate/view/${rowData._id}/grad`} target="_blank" rel="noopener noreferrer">View</a>
      ),
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
    {
      title: "Id Proof",
      field: "idproof",
      render: (rowData) => (
        <a href={`https://api.sgtu.ac.in/api/sgtuCertificate/view/${rowData._id}/idproof`} target="_blank" rel="noopener noreferrer">View</a>
      ),
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
    {
      title: "Additional",
      field: "additional",
      render: (rowData) => (
        <a href={`https://api.sgtu.ac.in/api/sgtuCertificate/view/${rowData._id}/additional`} target="_blank" rel="noopener noreferrer">View</a>
      ),
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
    {
      title: "Photo",
      field: "photo",
      render: (rowData) => (
        <a href={`https://api.sgtu.ac.in/api/sgtuCertificate/view/${rowData._id}/photo`} target="_blank" rel="noopener noreferrer">View</a>
      ),
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
    {
      title: "Created At",
      field: "createdAt",
      render: (rowData) => {
        const date = new Date(rowData.createdAt);
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
      },
      headerStyle: commonCellStyle,
      cellStyle: commonCellStyle,
    },
  ];

  return (
    <div className="dashboard-wrapper">
      <Toaster position="top-center" />
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />
      <main className="dashboard-main">
        <Header />
        <div className="main-section">
          {loading ? (
            <div className="loader-main">
              <div className="loader-box">
                <span></span><span></span><span></span><span></span>
              </div>
            </div>
          ) : (
            <div className="table-scroll-container">
              <MaterialTable
                title="Course Completion Certificate Data"
                columns={columns}
                data={tableData}
                options={{
                  tableLayout: "fixed",
                  search: true,
                  paging: true,
                  pageSize: 10,
                  pageSizeOptions: [5, 10, 20],
                  padding: "dense",
                  exportMenu: [
                    {
                      label: "Export to Excel",
                      exportFunc: (cols, datas) =>
                        ExportCsv(cols, datas, "Course_Completed_Certificates"),
                    },
                    {
                      label: "Export to PDF",
                      exportFunc: (cols, datas) =>
                        ExportPdf(cols, datas, "Course_Completed_Certificates"),
                    },
                  ],
                }}
              />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default CourseCompletionCertificate;